var angular = require('angular');
require('angular-google-analytics');

module.exports = function configure(app) {
  app.config(function (AnalyticsProvider) {
    AnalyticsProvider.setAccount({
      tracker: window.conf.ga_code,
      name: 'tracker1',
      trackEvent: true,
      fields: {
        cookieFlags: 'SameSite=Strict; Secure',
      },
    });

    AnalyticsProvider.logAllCalls(true);

    // Track all routes (default is true).
    AnalyticsProvider.trackPages(true);

    // Track all URL query params (default is false).
    AnalyticsProvider.trackUrlParams(true);

    // Change the default page event name.
    // Helpful when using ui-router, which fires $stateChangeSuccess instead of $routeChangeSuccess.
    AnalyticsProvider.setPageEvent('$stateChangeSuccess');
  });

  app.run(function (Analytics) {
    window.Analytics = Analytics;
  });
};
